var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "app-list mb-3", attrs: { fluid: "", "grid-list-xl": "" } },
    [
      _vm.selected.length || _vm.tableTitle
        ? _c("div", { staticClass: "table-title" }, [
            _c("div", { staticClass: "title-wrapper" }, [
              _vm.tableTitle
                ? _c("div", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.tableTitle)),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.selected.length && _vm.counterText
                ? _c("div", { staticClass: "counter" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.select.length) +
                        " " +
                        _vm._s(_vm.counterText) +
                        "\n      "
                    ),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _vm.selected.length
              ? _c(
                  "span",
                  { staticClass: "selected-text", on: { click: _vm.onDelete } },
                  [_vm._v("\n      " + _vm._s(_vm.selectedText) + "\n    ")]
                )
              : _vm._e(),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "" } },
        _vm._l(_vm.items, function (item, index) {
          return _c(
            "v-flex",
            { key: index, attrs: { xs12: "", sm6: "", md4: "", lg3: "" } },
            [
              _c(
                "v-toolbar",
                { attrs: { color: "secondary", flat: "" } },
                [
                  _c(
                    "v-toolbar-title",
                    { staticClass: "d-flex white--text" },
                    [
                      _vm.checkboxTable
                        ? _c("v-checkbox", {
                            attrs: {
                              primary: "",
                              "hide-details": "",
                              "input-value": item.selected,
                              value: true,
                              "value-comparator": () => !!item.selected,
                            },
                            on: {
                              change: function ($event) {
                                return _vm.selectPropsIfCan($event, item)
                              },
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("span", {
                        staticClass: "pt-2 pb-2",
                        domProps: { innerHTML: _vm._s(_vm.onTitle(item)) },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _vm.options
                    ? [
                        _vm.options.options(item).length
                          ? _c(
                              "v-menu",
                              {
                                attrs: {
                                  origin: "center center",
                                  transition: "scale-transition",
                                  bottom: "",
                                  left: "",
                                },
                              },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      slot: "activator",
                                      icon: "",
                                      id: "btn-more-vert-app-list",
                                    },
                                    slot: "activator",
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      { staticClass: "white--text" },
                                      [_vm._v("more_vert")]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-list",
                                  _vm._l(
                                    _vm.options
                                      .options(item)
                                      .filter(
                                        (option) =>
                                          option.show === undefined ||
                                          option.show === true
                                      ),
                                    function (option, jndex) {
                                      return _c(
                                        "v-list-tile",
                                        {
                                          key: jndex,
                                          on: {
                                            click: function ($event) {
                                              return _vm.emit(
                                                option.method,
                                                item,
                                                index
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "v-list-tile-title",
                                            { attrs: { id: option.id } },
                                            [_vm._v(_vm._s(option.title))]
                                          ),
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    : _vm._e(),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "v-card",
                { attrs: { flat: "" } },
                [
                  _c(
                    "v-list",
                    { attrs: { dense: "" } },
                    _vm._l(_vm.filteredHeaders, function (header) {
                      return _c(
                        "v-list-tile",
                        { key: header.text },
                        [
                          _c("v-list-tile-content", [
                            _c(
                              "div",
                              [
                                _c("span", [_vm._v(_vm._s(header.text))]),
                                _vm._v(" "),
                                header.tooltip
                                  ? _c(
                                      "v-tooltip",
                                      { attrs: { top: "" } },
                                      [
                                        _c(
                                          "v-icon",
                                          {
                                            attrs: {
                                              slot: "activator",
                                              small: "",
                                            },
                                            slot: "activator",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                header.tooltipIcon || "info"
                                              )
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(_vm._s(header.tooltip)),
                                        ]),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-list-tile-content",
                            { staticClass: "align-end" },
                            [
                              header.icon
                                ? _c(
                                    "v-icon",
                                    {
                                      class: _vm.iconClasses(header, item),
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.onActionIcon(header, item)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.getIcon(header, item)) +
                                          "\n              "
                                      ),
                                    ]
                                  )
                                : header.progress
                                ? _c("v-progress-linear", {
                                    attrs: {
                                      "background-color": "#E0E0E0",
                                      color: "#299D8D",
                                      value: header.progress(item),
                                    },
                                  })
                                : header.formatter
                                ? _c("div", {
                                    domProps: {
                                      innerHTML: _vm._s(header.formatter(item)),
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              header.toggle
                                ? _c(
                                    "div",
                                    [
                                      _c("v-switch", {
                                        staticClass: "table-toggle",
                                        attrs: { color: "secondary" },
                                        on: {
                                          change: function ($event) {
                                            return _vm.$emit("onToggle", item)
                                          },
                                        },
                                        model: {
                                          value: item[header.value],
                                          callback: function ($$v) {
                                            _vm.$set(item, header.value, $$v)
                                          },
                                          expression: "item[header.value]",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }